<!-- TelaExtraiDadosUsuario.svelte -->
<script>
  import ExtraiDadosBasico from "../../Componentes/ExtracaoDados/ExtraiDadosBasico.svelte";
  import ExibeItem from "../../Classes/exibeItem.js";
  import BotaoInserir from "../../componentes_basicos/BotaoInserir.svelte";
  import Pesquisa from "../../Componentes/ExtracaoDados/Pesquisa.svelte";
  
  import { onMount } from "svelte";
    import Permissoes from "../../Classes/ArmazenaPermissoesUsuario";
  // Define as propriedades para o componente ExtraiDadosBasico
  let termo_pesquisa = "";
  let extraiDadosBasico;
  const api = "consultas.php";
  const parametros = {
   
    query_code: "consulta_usuario",
    termo_pesquisa: termo_pesquisa,
    campos_pesquisaveis: ["nome_usuario", "id_empresa"],
  };
  const celulas = [
    new ExibeItem("Nome", "nome_usuario"),

    new ExibeItem("Email", "email"),
    new ExibeItem("Empresa", "nome_empresa"),
  ];

  //só precisa configurar acima disto
</script>
<div class="centralizar">
        


<Pesquisa
  {parametros}
  bind:value={termo_pesquisa}
  {extraiDadosBasico}
><ExtraiDadosBasico {api} {parametros} {celulas} bind:this={extraiDadosBasico} navegacao="/alterausuario"/>

</Pesquisa>
 {#if  Permissoes.PermissaoUsuario(Permissoes.Tipo.PODE_INSERIR_USUARIO)}
<BotaoInserir navegarPara={'/inserirusuario'} />
{/if}
</div>

<style>
  .centralizar {
      margin-top: 20px;
      margin-bottom: 100px;
        background-image: url('/img/backmenu.jpg');
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
  }
</style>
  